// src/components/auth/AuthForm.jsx
import { useState } from 'react'
import { Controller } from 'react-hook-form'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Checkbox } from '@/components/ui/checkbox'

const AuthForm = ({
  control,
  mode = 'login', // login | register
  loading,
  onSubmit,
  forgotPasswordLink, // React node (Link or button) to render after password field
}) => {
  const [acceptedTerms, setAcceptedTerms] = useState(false)

  return (
    <form onSubmit={onSubmit} className="space-y-4">

      {/* NAME (register only) */}
      {mode === 'register' && (
        <div className="space-y-2">
          <Label>الاسم</Label>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <Input placeholder="أحمد محمد" {...field} />
            )}
          />
        </div>
      )}

      {/* EMAIL */}
      <div className="space-y-2">
        <Label>البريد الإلكتروني</Label>
        <Controller
          name="email"
          control={control}
          render={({ field }) => (
            <Input
              type="email"
              placeholder="example@domain.com"
              {...field}
            />
          )}
        />
      </div>

      {/* PASSWORD */}
      <div className="space-y-2">
        <Label>كلمة المرور</Label>
        <Controller
          name="password"
          control={control}
          render={({ field }) => (
            <Input
              type="password"
              placeholder="••••••••"
              {...field}
            />
          )}
        />
      </div>

      {/* Forgot password link (only in login mode) - now RTL aligned */}
      {mode === 'login' && forgotPasswordLink && (
        <div className="text-right text-sm">
          {forgotPasswordLink}
        </div>
      )}

      {/* CONFIRM PASSWORD (register only) */}
      {mode === 'register' && (
        <div className="space-y-2">
          <Label>تأكيد كلمة المرور</Label>
          <Controller
            name="password_confirmation"
            control={control}
            render={({ field }) => (
              <Input
                type="password"
                placeholder="••••••••"
                {...field}
              />
            )}
          />
        </div>
      )}

      {/* TERMS AGREEMENT (register only) */}
      {mode === 'register' && (
        <div className="flex items-center space-x-2 space-x-reverse">
          <Checkbox
            id="terms"
            checked={acceptedTerms}
            onCheckedChange={(checked) => setAcceptedTerms(checked === true)}
          />
          <Label htmlFor="terms" className="text-sm font-normal">
            أوافق على{' '}
            <a href="/privacy-policy" target="_blank" className="text-primary hover:underline">
              سياسة الخصوصية
            </a>{' '}
            و{' '}
            <a href="/terms-of-service" target="_blank" className="text-primary hover:underline">
              شروط الاستخدام
            </a>
          </Label>
        </div>
      )}

      <Button 
        type="submit" 
        className="w-full" 
        disabled={loading || (mode === 'register' && !acceptedTerms)}
      >
        {loading
          ? mode === 'login'
            ? 'جاري الدخول...'
            : 'جاري الإنشاء...'
          : mode === 'login'
          ? 'تسجيل دخول'
          : 'إنشاء حساب'}
      </Button>
    </form>
  )
}

export default AuthForm